/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { ReactComponent as FileIcon } from 'Images/blank_reports_view.svg';
import { DropdownWrapper } from 'Screens/Contextualization/Manage/components/CreateActions/styled';

export const Wrapper = styled(DropdownWrapper)`
    width: 109px;
`;

export const Icon = styled(FileIcon).attrs({
  viewBox: '0 0 55 66'
})`
    width: 13px;
    height: 16px;
    display: block;
    overflow: visible;

    & path {
        fill: ${({ theme }) => theme.buttons.custom.color} !important;
    }

`;
